export const TEMPLATE_COOKIES = {
  ENABLE_LOGOUT_MODAL: 'enableLogoutModal',
  FORCE_UPDATE_JWT_IN_REDUCERS: 'forceUpdateJwtInReducers',
};
